export const MAX_MONEY_INPUT = 99999999.99

export enum CurrencyCodes {
  CAD = 'CAD',
  USD = 'USD',
}
